import { Component, Ref, log, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { CountUp } from 'countup.js';

@Component
export class StatsSection extends ThemeComponent {

    @Ref countupElements !: HTMLHeadingElement[];

    private amount: number = 0;
    private countupComplete: boolean = false;

    init() {

        const scrollPosition = this.getBoundingClientRect().top <= (window.innerHeight - 200);

        if(scrollPosition){
            this.performStats();
        }

        window.addEventListener('scroll', () => {
            const elementReached = this.getBoundingClientRect().top <= (window.innerHeight - 200);
            if (!this.countupComplete && elementReached) {
                this.performStats();
            }
        });
    }

    performStats() {
        for (const countupElement of this.countupElements) {
            const elementAmount = Number(countupElement.dataset.countup);
            const countUp = new CountUp(countupElement, elementAmount);
            countUp.start();
        }
        this.countupComplete = true;
    }
}
